import React from "react";
import { Toast } from "devextreme-react";
import { connect } from "react-redux";


class ToastCustomn extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      message: "",
    };
  }

  componentDidUpdate = () => {
    if (this.props.isConflictDownloadExcel || this.props.isPrestacionEmpresaDownloadLoading === true || this.props.isSiniestroDownloadLoading === true || this.props.isDenunciaDownloadLoading === true) {
      let message = "Descargando Excel ";
      let msgcompuesto = "";
      if (this.props.isPrestacionEmpresaDownloadLoading === true) {
        msgcompuesto += " Prestaciones económicas empresa.";
      }
      if (this.props.isSiniestroDownloadLoading === true) {
        msgcompuesto += " Siniestros empresa.";
      }
      if (this.props.isDenunciaDownloadLoading === true) {
        msgcompuesto += " Denuncias empresa.";
      }
      if(this.props.isConflictDownloadExcel === true) {
        msgcompuesto += " Informe de conflictos.";
      }
      message += msgcompuesto;
      this.setState({
        visible: true,
        message,
      });
    }

    if (this.props.isPrestacionEmpresaDownloadLoading === false && this.props.isSiniestroDownloadLoading === false && this.props.isDenunciaDownloadLoading === false) {
      this.setState({
        visible: false,
        message: "",
      });
    }
  }

  render() {
    return (

      <Toast
        className="custom-download-file"
        visible={this.state.visible}
        message={this.state.message}
        displayTime={5000}
        type="success"
      />
    );
  }
}
const mapStateToProps = (state) => ({

  isDenunciaDownloadLoading: state.denuncias.isDownloadLoading,
  isSiniestroDownloadLoading: state.siniestroEmpresa.isDownloadLoading,
  isPrestacionEmpresaDownloadLoading: state.prestacionesEmpresa.isDownloadLoading,
  isConflictDownloadExcel : state.aperturasSel.isDownloadExcel,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ToastCustomn);

